import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { Icon } from 'ui';
import request from 'utils/request_ajax';
import { routes as ROUTES } from 'constants/config';
import * as selectors from 'selectors/pathBuilder';
import Section from './Section';

const Button = ({ icon, children, className = '', ...props }) => (
  <a
    {...props}
    className={
      'NewButton NewButton--white NewButton--center undecorated c-brand-gray-darker f-1 ' +
      className
    }
  >
    {icon && <Icon name={icon} className="mr-4" />}
    {children}
  </a>
);

const handleCopy = pathId => {
  request.postJSON(ROUTES.PATH_COPY(pathId)).done(data => {
    request.getScript(ROUTES.NOTIFICATIONS_LATEST);
  });
};

const Buttons = ({
  pathId,
  isArchived,
  isPublished,
  previewUrl,
  userCanManageContent,
  userCanCopyContent,
}) => {
  if (!pathId) return false;
  return (
    <Section className="Sidebar-Buttons">
      <div className="d-f mb-12">
        {previewUrl && (
          <Button icon="preview" href={previewUrl}>
            {t('actions.preview')}
          </Button>
        )}
      </div>
      <div className="d-f Sidebar-Buttons-horizontal">
        {isPublished && userCanCopyContent && (
          <Button
            icon="copy"
            rel="nofollow"
            onClick={() => {
              handleCopy(pathId);
            }}
          >
            {t('common.copy')}
          </Button>
        )}
        {!isArchived && userCanManageContent && (
          <Button
            data-confirm="Archiving this path will remove live data from users and the gradebook."
            icon="archive"
            data-method="put"
            href={ROUTES.PATH_ARCHIVE(pathId)}
          >
            {t('actions.archive')}
          </Button>
        )}
        {isArchived && userCanManageContent && (
          <Button
            className="ml-8"
            icon="restore"
            data-method="put"
            href={ROUTES.PATH_RESTORE(pathId)}
          >
            {t('actions.restore')}
          </Button>
        )}
      </div>
    </Section>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  pathId: pathBuilder.id,
  isArchived: selectors.isArchived(pathBuilder),
  isPublished: !!get('publishedAt.date')(pathBuilder),
  previewUrl: get('urls.preview', pathBuilder),
  userCanManageContent: pathBuilder.permissions.editPath,
  userCanCopyContent: pathBuilder.permissions.copyPath,
});

export default connect(mapStateToProps)(Buttons);
